import { createSelector } from 'reselect';

import type { State } from 'reducers';

import { initialState } from './reducers';

const selectState = (state: State) => state.get('donationGivingRulesListPage') || initialState;

export const selectInitialized = createSelector(selectState, (state) => state.get('initialized'));

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));
